import React, { useState } from 'react';

import { FormattedMessage } from '../../../plugins/publicis-gatsby-plugin-i18n';
import { CoputerIcon } from '../../Atoms/Icons/Icons'
import './discoverstores.scss';
import { trackPopinGalaxie } from '../../Utils/Tracking';

const classNames = require('classnames');

const DiscoverStores = ({ smaller, sticky, position }) => {

  const [popinOpened, setPopinOpened] = useState(false);


  const handleOpenPopin = (e) => {
    e.preventDefault();
  
    document.body.classList.remove('scroll-down');
    document.body.classList.add('show_popin_stores', 'popin_open');
    setPopinOpened(true);
    document.querySelector('#close_popin_discover_sites').focus();
  
    if(position == "footer")
    {
      trackPopinGalaxie('clic_popin_galaxie','accueil','home','footer','popin_galaxie')
    }
 
  };

  const onFocusEvent = (e) => {
    e.currentTarget.parentNode.classList.remove('smaller');
  }

  return (
    <div className={classNames('sticky-container', { 'smaller': smaller, 'sticky': sticky })} >
      <a className="sticky-allsites" href="##a" onClick={handleOpenPopin} onFocus={onFocusEvent} aria-expanded={popinOpened ? "true" : "false"}>
        <div className="icon">
          <CoputerIcon color="#000000" />
        </div>
        <FormattedMessage
          id="store.discover.title"
          values={{
            br: <br />,
            strong: s => <strong>{s}</strong>
          }} >
          {x => <div className="txt">{x}</div>}
        </FormattedMessage>
      </a>
    </div>
  );
};

export default DiscoverStores;
